var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWCondensedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960.04 254.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:114.6px;font-family:GillSansMT-Bold, Gill Sans MT;font-weight:700;}.cls-1,.cls-12,.cls-13{fill:#fff;}.cls-2{letter-spacing:-0.04em;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:0.03em;}.cls-5{letter-spacing:0em;}.cls-6{letter-spacing:-0.02em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:-0.01em;}.cls-9{letter-spacing:-0.04em;}.cls-10{letter-spacing:-0.08em;}.cls-11{letter-spacing:-0.1em;}.cls-12{font-size:44.01px;font-family:GillSansMT, Gill Sans MT;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "w_condensed_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(229.38 106.11)"
  }, "Str", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 167.09,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 223.89,
    y: 0
  }, "wbe"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 443.41,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 493.66,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 548.44,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(259.64 192.29)"
  }, "Phot", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 256.56,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 322.93,
    y: 0
  }, "gr"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 436.41,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 496.12,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 562.93,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 625.71,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 674.96,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(509.98 241.71)"
  }, "By Sarah Hunt "), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M178.2,102.32c-1.5-7.6-5.56-14.08-9-20.84a4,4,0,0,0-.72-1C161.22,73.53,155,65.36,145.58,61a12.42,12.42,0,0,1-1.2-.9c4.44-1.21,8.79-2,10.9-6.44l-6.21.48-.15-.74c6.09-3.08,12-6.4,15.25-12.78a16,16,0,0,0,1.42-5c-3.45,5-8.87,4.16-13.64,4.95a89.94,89.94,0,0,1-11.19,1.26c-1.15,0-2.34-1.31-3.94-2.3a8.65,8.65,0,0,1-7.85,5c1.18-3.41,3-6.7,3.34-10.14.37-3.66-1.55-7-3.95-9.63l-17.44,9.4s-.23-.07-.3-.19c-2-3.35-2-3.28-5.8-2.2-5.76,1.62-11.36,3.49-15.76,7.83-.15.14-.46.12-1.25.32-.4-2-.89-4-1.16-6a34.34,34.34,0,0,1,1.81-17.27c2.47-6.36,6.81-9.09,13.41-8.25,2.7.34,3.26-1.54,3.89-3.34s.81-3.51-1.52-4.31A9.92,9.92,0,0,1,102.9,0h-5a3.78,3.78,0,0,1-.43.26C85.67,5.61,80.13,15.77,82,28.85c.71,4.92,1.72,9.79,2.44,14.93C81.67,33.55,71.63,31.63,64.54,25.94c-2.78,3.07-6.91,4.8-8.14,9.22-.41,1.5-1.51,1.49-2.52.66-2-1.61-3.86-3.33-6-5.21-2.23,4.32-.79,9-.91,13.75-1-.21-1.58-.36-2.21-.47-4.25-.75-8.57-2.35-12.74-2-6.75.52-12.25-1.76-17.61-5.19-.67-.43-1.37-.8-2.06-1.2l-.56.5C16,42.28,20.21,48.59,24.58,55.14c-1.71-.76-3.56-1.44-5.26-2.39s-3.27-2.18-5.08-3c3.45,6.45,8.5,10.85,16.78,12.12L28.34,64C24.85,66.78,21,69.24,18,72.52c-4,4.4-7.91,8.81-10.83,14.28C4,92.81,2.56,99.29,0,105.41V125c1.2,4.87,1.89,9.93,3.7,14.55a253.62,253.62,0,0,0,10.83,24.16c5.06,9.77,10.65,19.28,16.24,28.76,4.41,7.47,9.11,14.77,13.79,22.07a131,131,0,0,0,8.89,12.93c2.06,2.5,5,4.34,7.77,6.17,6.33,4.18,13.45,6.1,20.93,6.83a18.91,18.91,0,0,1,2.18.48h11a34.21,34.21,0,0,1,4.62-1.05,42.63,42.63,0,0,0,19.54-7.06c6.4-4.17,10.36-10.58,14.42-16.77,4.89-7.46,9.44-15.15,14-22.83,3.42-5.82,6.51-11.82,9.85-17.68,3.22-5.65,6.92-11.06,9.78-16.88,5.15-10.49,9.6-21.28,11.25-33a7.46,7.46,0,0,1,.4-1.18V105.41A29.17,29.17,0,0,1,178.2,102.32Zm-71.33,66.19q-6.93,5.4-18.24,5.4A48.36,48.36,0,0,1,65,167.57V153.44a64.9,64.9,0,0,0,11.65,6.43,28.89,28.89,0,0,0,10.75,2q9.61,0,9.62-6.06a5.37,5.37,0,0,0-1.92-3.89q-1.94-1.83-9.28-4.46a93.93,93.93,0,0,1-11.64-4.88,22,22,0,0,1-7.42-6.43,17.44,17.44,0,0,1-3.12-10.71,16.33,16.33,0,0,1,6.81-13.64q6.81-5.19,18.22-5.19a55.82,55.82,0,0,1,22.2,5.07v12.81q-13-5.87-20.79-5.86a14.26,14.26,0,0,0-7,1.47A4.43,4.43,0,0,0,80.41,124a4.82,4.82,0,0,0,1.88,3.57q1.88,1.7,9.15,4.37a97.63,97.63,0,0,1,11.65,5,22.63,22.63,0,0,1,7.53,6.47A17,17,0,0,1,113.79,154,17.47,17.47,0,0,1,106.87,168.51Zm29.11,3a8.38,8.38,0,0,1-11.84,0,8.37,8.37,0,0,1,5.9-14.27,8.42,8.42,0,0,1,8.4,8.36A8,8,0,0,1,136,171.46Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWCondensedLogo);
export default __webpack_public_path__ + "static/media/w_condensed_logo.d9e5636c6b031feba362d5f209b8fdc2.svg";
export { ForwardRef as ReactComponent };